import { clsx } from 'clsx'
import { LoaderCircle } from 'lucide-react'

export function Spinner({ className }: { className?: string }) {
  return <LoaderCircle className={clsx('animate-spin text-muted', className ?? 'size-5')} aria-hidden />
}

export function FullPageSpinner({ label }: { label?: string }) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3" role="status">
      <Spinner className="size-7" />
      {label && <p className="text-sm text-muted">{label}</p>}
    </div>
  )
}
